import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { useRecoilValue } from 'recoil';
import {
  changeHoverColor,
  disableActiveBackground,
  getContactButtonHoverColor,
} from '..';
import { backgroundThemeState, darkModeState } from '../../atoms';
import { SideBarInfo } from '../../components/navbar/SideBarInfo';
import { Project } from '../../data';
import { expand } from '../../data/photoUrls';

export const useIcon = (icon: string) => {
  const darkMode = useRecoilValue(darkModeState);

  return darkMode ? icon : icon.replace('ffffff', '000000');
};

export function useActiveState(navLinks: SideBarInfo[], activeIndex: string) {
  function activeBackground(elementId: string, backgroundColor: string) {
    const navNode = document.getElementById(elementId);
    const prevNavId = navLinks.find((item) => item.path === activeIndex)?.id;
    disableActiveBackground(prevNavId!);

    if (navNode) {
      navNode.style.backgroundColor = backgroundColor;
      navNode.style.color = 'black';
    }
  }

  return [activeBackground];
}

export function useHover() {
  return {
    hover(item: SideBarInfo | Project) {
      if ('id' in item) changeHoverColor(item.id, item.hoverColor);
      else changeHoverColor(item.name, item.bg);
    },
  };
}

export function useContactButtonHover(background: string, className?: string) {
  const node = document.querySelector(
    className ? className : '.stretch'
  ) as HTMLElement;
  if (node) {
    node.style.setProperty(
      '--before-hover-color',
      getContactButtonHoverColor(background)
    );
  }
}

export function useAnimationForBackGround(
  enter: boolean,
  access: boolean,
  className: string
) {
  const background = useRecoilValue(backgroundThemeState);

  useGSAP(
    () => {
      if (enter) {
        gsap.fromTo(
          `.${className}`,
          {
            duration: 2,
            opacity: 0,
          },
          {
            duration: 2,
            opacity: 1,
          }
        );
        return;
      }

      if (access) {
        gsap.fromTo(
          `.${className}`,
          {
            duration: 2,
            opacity: 0,
          },
          {
            duration: 2,
            opacity: 1,
          }
        );
        return;
      }

      if (className === 'img') {
        gsap.fromTo(
          `.${className}`,
          {
            duration: 2,
            opacity: 0,
          },
          {
            duration: 2,
            opacity: 1,
          }
        );
      }
    },
    { dependencies: [expand, access, background], revertOnUpdate: true }
  );
}
